import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class BlacklistComponent extends Component {
  static readonly TYPE_ID: string = '8014bcf3d6774bfc947e89e9e3389d89';

  constructor(
    public readonly isBlacklisted: boolean,
  ) {
    super();
  }

  get $typeId(): string {
    return BlacklistComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): BlacklistComponent {
    return new BlacklistComponent(
        MapUtils.get<boolean>(map, 'isBlacklisted'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'isBlacklisted': this.isBlacklisted,
    };
  }

  clone(): this {
    return new BlacklistComponent(
        this.isBlacklisted,
    ) as this;
  }

  isSame(other: BlacklistComponent): boolean {
    if(this === other) {
      return true;
    }

    return other.isBlacklisted === this.isBlacklisted;
  }
}

export class BlacklistComponentBuilder extends DataModelBuilder<BlacklistComponent> {
  build(context: SerializationContext, map: SerializedData): BlacklistComponent {
    return BlacklistComponent.fromMap(context, map);
  }
}
